import { Component } from '@angular/core';
import { CommonService } from '../../../../../services/common';
import { SalesService } from '../../../sales.service';

@Component({
  selector: 'app-document-details',
  templateUrl: './document-details.component.html',
  styleUrl: './document-details.component.scss'
})
export class DocumentDetailsComponent {

  constructor(public commonService:CommonService, public salesService:SalesService){

  }
}
